import * as types from 'store/visitSummary/types';

export const initialFilterState: types.VisitSummaryFilter = {
  provider: '',
  location: '',
  visitType: '',
  year: null,
  startDate: '',
  endDate: ''
};

export const sortOptions: types.SortOptions[] = [
  {
    key: 1,
    label: 'New to Old',
    selected: true,
    value: 'desc',
    dirty: false
  },
  {
    key: 2,
    label: 'Old to New',
    selected: false,
    value: 'asc',
    dirty: false
  }
];
